const mapLayers = {
  options: {
    layers: 'Layers',
    ev: 'EV',
    bookings: 'Bookings',
    heatMap: 'Heat Map',
  },
  legend: {
    powerType: {
      slow: 'Lento',
      fast: 'Rápido',
      turbo: 'Turbo',
    },

    availability: {
      available: 'Disponível',
      notAvailable: 'Não disponível',
      selected: 'Selecionado',
      broken: 'Problema',
      unknown: 'Desconhecido',
    },
  },
};

export default mapLayers;
